import {setupRowSelectionColumn} from "./row-selection/setup-row-selection";

/**
 * Handles any custom column types in the colDefs
 *
 * @param gridOptions
 */
function setupCustomColumnTypes(gridOptions) {
	const colDefs = gridOptions.columnDefs;
	const customColumns = colDefs.filter(col => col._customType);

	customColumns.forEach(col => {
		/** @var {GridCustomColumnTypeValue} customColumnType*/
		const customColumnType = col._customType;

		switch (customColumnType) {
			case "custom-type-row-picker":
				setupRowSelectionColumn(gridOptions, col);
				break;
			default:
				throw `Unknown custom column type ${customColumnType}`
		}

	})

	/** Method */
}

export {setupCustomColumnTypes};
